/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "../../axios";

export default {
  async getOrders({ commit }) {
    try {
      let orders = await axios.get("/api/orders");
      console.log(orders);
      commit("UPDATE_ORDERS", orders.data.orders);
    } catch (error) {
      console.log(error);
    }
  },
  async getDeliveryTime({ commit }) {
    try {
      let deliveryTime = await axios.get("/api/delivery-time");
      commit("UPDATE_DELIVERY_TIME", deliveryTime.data.deliveryTime.time);
      commit(
        "UPDATE_DELIVERY_ACTIVATION",
        deliveryTime.data.deliveryTime.isPossible,
      );
    } catch (error) {
      console.log(error);
    }
  },
  async updateDeliveryTime({ commit }, payload) {
    try {
      let deliveryTime = await axios.put("/api/delivery-time", {
        time: parseInt(payload),
      });
      commit("UPDATE_DELIVERY_TIME", deliveryTime.data.deliveryTime.time);
    } catch (error) {
      console.log(error);
    }
  },
  async deliveryActivation({ commit }, payload) {
    try {
      let deliveryTime = await axios.put("/api/delivery-time/activation", {
        isPossible: payload,
      });
      commit(
        "UPDATE_DELIVERY_ACTIVATION",
        deliveryTime.data.deliveryTime.isPossible,
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getPaidOrders({ commit }) {
    try {
      let orders = await axios.get("/api/orders/paid");
      commit("UPDATE_ORDERS_PAID", orders.data.orders);
    } catch (error) {
      console.log(error);
    }
  },
  async getOrderedNotPaidOrders({ commit }) {
    try {
      let orders = await axios.get("/api/orders/ordered-not-paid");
      commit("UPDATE_ORDERS_ORDERED_NOT_PAID", orders.data.orders);
    } catch (error) {
      console.log(error);
    }
  },
  async getPaidAndSentOrders({ commit }) {
    try {
      let orders = await axios.get("/api/orders/paid-and-sent");
      commit("UPDATE_ORDERS_PAID_AND_SENT", orders.data.orders);
    } catch (error) {
      console.log(error);
    }
  },
  async updateOrderStatusIsSent({ commit }, orderID) {
    try {
      let order = await axios.put(`/api/orders/sent/${orderID}`);
      commit("UPDATE_ORDER_IS_SENT", order.data.order);
    } catch (error) {
      console.log(error);
    }
  },
  async updateOrderStatusIsSeen({ commit }, orderID) {
    try {
      let order = await axios.put(`/api/orders/seen/${orderID}`);
      commit("UPDATE_ORDER_IS_SEEN", order.data.order);
    } catch (error) {
      console.log(error);
    }
  },
};
